import {useSyncExternalStore} from 'react';

const getIsPageVisible = (): boolean =>
  typeof document === 'undefined' || document.visibilityState === 'visible';

// Outside the hook so React doesn't resubscribe on every render.
const subscribe = (onChange: () => void): (() => void) => {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
};

/**
 * Whether the tab is on screen (not in the background or minimized).
 *
 * Deliberately ignores window focus: focus is lost to devtools, notifications
 * and second monitors while the user is still looking at the page.
 *
 * @returns Whether the page is currently visible
 */
export const usePageVisibility = (): boolean =>
  useSyncExternalStore(subscribe, getIsPageVisible);
